import dayjs from 'dayjs'

export const getDataType = (object) => {
  return Object.prototype.toString.call(object)
}
export const isArray = (o) => {
  return getDataType(o) === '[object Array]'
}
export const isNumber = (o) => {
  return getDataType(o) === '[object Number]'
}
export const isString = (o) => {
  return getDataType(o) === '[object String]'
}
export const isObject = (o) => {
  return getDataType(o) === '[object Object]'
}
export const isSymbol = (o) => {
  return getDataType(o) === '[object Symbol]'
}
export const isBoolean = (o) => {
  return getDataType(o) === '[object Boolean]'
}
export const isFunction = (o) => {
  return getDataType(o) === '[object Function]'
}
export const isBaseTypeData = (o) => {
  return isNumber(o) || isString(o) || isBoolean(o)
}
export const storage = {
  /**
   * @param key
   * @param dataSource
   * @param storageType 指定的storage default: localStorage
   */
  setItem (key, dataSource, storageType = 'localStorage') {
    if (!key) {
      throw new Error('存储的key不能为空')
    }
    let storage = window[storageType]
    if (!storage) {
      throw new Error('指定的storage不存在或浏览器不支持!')
    }
    if (!isBaseTypeData(dataSource)) {
      storage.setItem(key, JSON.stringify(dataSource))
    } else {
      storage.setItem(key, dataSource)
    }
  },
  /**
   * @param key
   * @param isBaseType 指定返回的结果 false: 非基本类型，返回的是JSON.parse之后的结果, 若为true 则为基本类型不 --- 暂定
   * @param storageType
   * @returns {*|null|DOMPoint|SVGNumber|string|SVGTransform|SVGLength|SVGPathSeg|T|null|any}
   */
  getItem (key, isBaseType = false, storageType = 'localStorage') {
    if (!key) {
      return null
    }
    let storage = window[storageType]
    if (!storage) {
      throw new Error('指定的storage不存在或浏览器不支持!')
    }
    let data = storage.getItem(key) || null
    if (!data) {
      return null
    } else {
      return JSON.parse(data)
    }
    // if (isBaseType) {
    //   return data
    // } else {
    //   return JSON.parse(data)
    // }
  },

  removeItem (key, storageType = 'localStorage') {
    if (!key) {
      throw new Error('指定删除的key不存在')
    }
    let storage = window[storageType]
    if (!storage) {
      throw new Error('指定的storage不存在或浏览器不支持!')
    }
    window[storageType].removeItem(key)
  },

  clear (storageType = 'localStorage') {
    window[storageType].clear()
  },

  clearAll () {
    window.localStorage.clear()
    window.sessionStorage.clear()
  }
}

export const translateForArray = array => {
  if (array.length !== 0) {
    array.forEach(it => {
      // console.log(dayjs(it.createTime).format('YYYY-MM-DD HH:mm:ss'))
      it.createTime && (it.createTimeStr = dayjs(it.createTime).format('YYYY-MM-DD HH:mm:ss'))
      it.updateTime && (it.updateTimeStr = dayjs(it.updateTime).format('YYYY-MM-DD HH:mm:ss'))
    }, this)
  }
  return array
}

/**
 * 获取用户角色的树
 * @param rootName
 * @param array
 * @returns {{expand: boolean, children: Array, title: string}[]|*}
 */
export const getUserRoleTree = (rootName, array) => {
  if (array.length === 0) return array
  let rootTree = {
    title: '角色',
    expand: true,
    children: []
  }
  let children = array.map(it => {
    return {
      title: it.name,
      expand: true,
      checked: it.auth,
      auth: it.auth,
      id: it.id,
      descript: it.descript,
      children: (it.childRole && it.childRole.length !== 0) ? getUserRoleTree(it.name, it.childRole) : []
    }
  }, this)
  rootTree.children = children
  return [rootTree]
}

/**
 * 取用户角色修改后的数据
 * @param tree
 * @returns {Array}
 */
export const diffUserRoleTree = tree => {
  let res = []
  tree[0].children.forEach(it => {
    if (it.children && it.children.length !== 0) {
      return diffUserRoleTree(it.children)
    } else {
      if (it.auth !== it.checked) {
        res.push(it)
      }
    }
  })
  return res
}

export const getPlatMenuTree = (rootName, array) => {
  if (array.length === 0) return array
  let rootTree = {
    title: rootName,
    expand: true,
    children: []
  }
  const getChildTree = data => {
    return data.map(it => {
      let flag = (it.childrenExtend && it.childrenExtend.length !== 0)
      let name = it.status === 'N' ? `${it.name}(已禁用)` : it.name
      let o = Object.assign({}, it, {
        title: name,
        name: it.name,
        expand: false,
        checked: flag ? !flag : it.valid,
        children: flag ? getChildTree(it.childrenExtend) : []
      })
      return o
    })
  }
  rootTree.children = getChildTree(array)
  return [rootTree]
}

/**
 * @param tree 树结构原始数据
 * @param array 选中和半选数据
 * @returns {Array} 有改动的对象数组
 */
export const getDiffPlatRoleMenu = (tree, array) => {
  let res = [] // 最终结果
  tree.forEach(item => { // 之所以不用map，因为map必要return，在不符合条件的情况下可能为 []
    let treeMenuCode = item.menuCode || ''
    let stash = []
    let hasChecked = false
    array.forEach(it => {
      let arrayMenuCode = it.menuCode
      // menuCode一致时且后端返回的valid为false时，是从未选中变成选中
      if ((treeMenuCode === arrayMenuCode) && !item.valid) {
        stash.push(item)
      } else if ((treeMenuCode === arrayMenuCode) && item.valid) { // menuCode一致，最初就是选中的状态 没有变化
        hasChecked = true
      }
    })
    // 节点被没有被选中，但初始是选中状态，节点变化，变成未选中
    if (!hasChecked && stash.length === 0 && item.valid) {
      stash.push(item)
    }
    // 组合数据
    if (item.children && item.children.length !== 0) {
      let child = getDiffPlatRoleMenu(item.children, array)
      stash = child.length > 0 && stash.concat(child)
    }
    if (stash.length > 0) {
      res = res.concat(stash)
    }
  })
  return res
}
